var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoNolWhiteH12 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 13,
  fill: "none",
  viewBox: "0 0 32 13"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Logo",
  clipPath: "url(#clip0_10831_43349)",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  fill: "#fff",
  fillRule: "evenodd",
  d: "M17.287.5c-3.325 0-6.03 2.692-6.03 6s2.705 6 6.03 6 6.03-2.692 6.03-6-2.705-6-6.03-6m0 9.449c-1.911 0-3.466-1.547-3.466-3.45 0-1.902 1.554-3.448 3.466-3.448s3.466 1.546 3.466 3.449-1.554 3.449-3.466 3.449M7.755 6.985 5.44 2.506a2.86 2.86 0 0 0-3.252-1.43C.879 1.402 0 2.523 0 3.862v7.836c0 .099.08.179.18.179h2.183c.099 0 .18-.08.18-.179V3.894c-.001-.067-.001-.302.264-.368.264-.067.385.154.417.213l4.305 7.95a.36.36 0 0 0 .316.188h2.26a.18.18 0 0 0 .179-.178V1.303a.18.18 0 0 0-.18-.18H7.935c-.099 0-.18.081-.18.18zm19.114.983c0 .74.604 1.342 1.348 1.342v-.001h3.603c.099 0 .18.08.18.179v2.21a.18.18 0 0 1-.18.179h-3.753c-2.091 0-3.786-1.687-3.786-3.768V1.301a.18.18 0 0 1 .18-.178h2.228c.1 0 .18.08.18.178z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_10831_43349"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h32v12H0z"
})))));
export default SvgLogoNolWhiteH12;